export const AUDIO_PROCESSING = {
    // AudioContext sample rate — matches Opus codec's preferred rate for best quality
    SAMPLE_RATE: 48_000,

    // High-pass filter: removes desk rumble, breath pops, and handling noise below 80 Hz
    HPF_FREQUENCY: 80,
    HPF_Q: 0.7,

    // Low-mid cut: tames the "boxy" 400-500 Hz resonance common in small capsule mics
    LOW_MID_CUT_FREQUENCY: 450,
    LOW_MID_CUT_GAIN: -2.5,
    LOW_MID_CUT_Q: 0.9,

    // Lower presence boost: broad lift at 2.5 kHz adds warmth and fundamental clarity
    LOWER_PRESENCE_FREQUENCY: 2_500,
    LOWER_PRESENCE_GAIN: 3,
    LOWER_PRESENCE_Q: 1.0,

    // Upper presence boost: 5 kHz zone sharpens consonants (t, d, k, p) and overall crispness
    UPPER_PRESENCE_FREQUENCY: 5_000,
    UPPER_PRESENCE_GAIN: 3,
    UPPER_PRESENCE_Q: 1.3,

    // Air shelf: adds the open, "Discord" high-end above 10 kHz (s, sh, ch sibilants)
    // 10 kHz sits above the harsh 8 kHz zone — more natural air, less digital brightness
    AIR_FREQUENCY: 10_000,
    AIR_GAIN: 2.5,

    // Dynamics compressor: replaces browser's AGC with a more transparent, musical compressor
    COMPRESSOR_THRESHOLD: -16, // dBFS — less aggressive, preserves natural dynamics
    COMPRESSOR_KNEE: 8, // wider knee = softer, more transparent onset
    COMPRESSOR_RATIO: 2.5, // gentler ratio — less pumping, more natural
    COMPRESSOR_ATTACK: 0.005, // seconds — slightly slower attack preserves initial transients
    COMPRESSOR_RELEASE: 0.6, // seconds — long enough for natural voice tail, no more "Abgehackt"

    // Output gain: slight bump since we compress less aggressively now
    OUTPUT_GAIN: 0.9,
} as const;

// WebRTC getUserMedia constraints applied at the browser level (before our processing chain)
export const AUDIO_CONSTRAINTS: MediaTrackConstraints = {
    echoCancellation: true,
    noiseSuppression: true,
    // Disabled in favor of our DynamicsCompressor which gives better, more consistent results
    autoGainControl: false,
};
